import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import StorageService from "../../util/storage";

const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    }
});

export const fetchNewsList = async (orgId) => {
    const query = gql`
        query GetNews($id: String!) {
            newsItems(filters: { organisation: { orgId: { eq: $id } } }) {
                data {
                    id
                    attributes {
                        Title
                        Cover {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }
                        Summary
                        Description
                        publishedAt
                        publishedDate
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { id: orgId },
    });
    return data.newsItems.data;
};

export const fetchNewsList2 = async (orgId) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/news-items?populate=*&filter[organisation][orgId][$eq]=${orgId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response;
};

export const fetchNewsItem = async (id, orgId) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/news-items/${id}?populate=*`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response;
};
